import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AdminAuthService } from '../services/admin-auth.service';
import { environment } from '../../environments/environment';

export const adminAuthGuard: CanActivateFn = (route, state) => {
  // Internal instance uses Windows auth — no JWT guard needed
  if (!environment.externalAdminAuth) return true;

  const authService = inject(AdminAuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) return true;

  router.navigate(['/admin/login'], { queryParams: { returnUrl: state.url } });
  return false;
};
